import {
  geoAreaLocationProviderDirectoryPath,
  geoAreaLocationProviderDirectoryURL,
  slugify,
} from "../utils/paths"

import { logAnalytics } from "../utils/analytics"

export function metaDescription(pageType, locationName, isTown, careHomeCount) {
  const careHomeDescription = isTown
    ? `Free & impartial comparison of residential care homes in ${locationName}. Care Sourcer helps you find the best care package available in ${locationName} or the surrounding areas.`
    : `With ${careHomeCount} residential care homes in ${locationName}, Care Sourcer can help you compare all your options to find the best care available in ${locationName}.`

  // eslint-disable-next-line max-len
  const homeCareDescription = `Compare home care in ${locationName} with Care Sourcer. We can help you compare all care homes to find the best home care for you or your loved one in ${locationName}.`

  return {
    home_care: homeCareDescription,
    care_home: careHomeDescription,
    undefined: `View all elderly care providers in ${locationName} with Care Sourcer. We can help you compare all home care and care home providers to find the best care solution in ${locationName}.`,
    dementia: `Compare dementia care homes in ${locationName} and surrounding areas on Care Sourcer and find your loved one the best care package available in ${locationName}.`,
  }[pageType]
}

export function metaTitle(pageType, locationName) {
  return {
    home_care: `Home Care in ${locationName} | Search ${locationName} Home Care | Compare Care at Home Providers | Care Sourcer`,
    care_home: `Care Homes in ${locationName} | Search ${locationName} Care Homes | Care Sourcer`,
    undefined: `Elderly Care in ${locationName} | Search ${locationName} Elderly Care | Care Sourcer`,
    dementia: `Dementia Care Homes in ${locationName} | Search ${locationName} Dementia Care Homes | Care Sourcer`,
  }[pageType]
}

export const filterLinks = (careType, geoPathData) => {
  // only return locations that have branch records so that the page is not linking to non-existent pages
  switch (careType) {
    case "home_care":
      return geoPathData.filter((node) => node.homeCareCount > 0)
    case "care_home":
      return geoPathData.filter((node) => node.careHomeCount > 0)
    default:
      return geoPathData.filter(
        (node) => node.careHomeCount + node.homeCareCount > 0,
      )
  }
}

const formatGeoType = (geoPathData) => {
  const currentPath = geoAreaLocationProviderDirectoryPath(geoPathData)

  // given /providers/regions/london/care-home/1
  // regions/london is returned
  const regex = /\/providers\/([^/]*\/[^/]*)\/.*/
  return currentPath.replace(regex, "$1")
}

export const buildPageLoadEvent = (
  careType,
  locationName,
  geoSelfPathData,
  branchRecordCounts,
  branchRecordsOnPageCount,
  careServiceType,
) => () => {
  const amplitudeData = {
    eventType: "SEO - Filtered Directory Viewed",
    eventProperties: {
      "Care Type": careType,
      "Geo Location": locationName,
      "Current URL": geoAreaLocationProviderDirectoryURL(
        geoSelfPathData,
        careServiceType,
      ),
      "Search results with photos count":
        branchRecordCounts.countOfProvidersWithPhotos,
      "Search results with intro blurb count":
        branchRecordCounts.countOfProvidersWithIntroBlurb,
      "Search results with prices count":
        branchRecordCounts.countOfProvidersWithPrices,
      "Premium providers count": branchRecordCounts.countOfPremiumProviders,
      "Provider listings count": branchRecordsOnPageCount,
    },
  }

  const googleAnalyticsData = {
    geoType: formatGeoType(geoSelfPathData, careType),
    careType: careType ? slugify(careType) : null,
    registered: null,
    pageType: `${geoSelfPathData.geographicScale}-directory`,
  }

  logAnalytics(amplitudeData, googleAnalyticsData)
}
